<m-title>{{ header }}</m-title>

<div class="mip-btn-container">
    <p-button
        label="Filters"
        icon="pi pi-filter-fill"
        (onClick)="toggleFilter()"
        styleClass="p-button-secondary mip-marbtn-r"></p-button>
</div>

<div [hidden]="!filterVisible" class="card card-pad-mod">
    <filter #gridFilter [settings]="filterSettings"
        (filterSetChange)="filterInitialized()" (clearFilter)="clearFilter()">
        <ng-template filterCustomTemplate="patientId" let-filterItem>
            <div id="category-filter-container" class="flex align-items-center justify-content-center">
                <span class="p-float-label sm:w-12">
                    <p-multiSelect
                        [(ngModel)]="filterItem.value"
                        [ngModelOptions]="{standalone: true}"
                        [placeholder]="filterItem.settings.header"
                        [options]="filterItem.settings.dropdownOptions"
                        [showClear]="true"
                        appendTo="body"
                        (onChange)="gridFilter._onSelectableInputChanged(filterItem)"
                        (onClear)="onPatientFilterClear()"
                        styleClass="w-12">
                    </p-multiSelect>
                    <label>{{ filterItem.settings.header }}</label>
                </span>
            </div>
        </ng-template>
    </filter>
</div>

<div class="card main-container">
    <grid [tableSettings]="tableSettingsFormioDataViewer"
            [gridSettings]="formioViewerDataGridSettings"
            [filter]="gridFilter"
            [(selection)]="selectedFormData"
            (delete)="onGridDeleteHandler()">
        <ng-template gridColumnTemplate="displayingRow" columnName="episodeName" let-rowData>
            <div [ngStyle]="{'white-space': 'pre-line'}" [innerHTML]="rowData.episodeName">
            </div>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="dataGrid._getColumnsCount()">
                    <medical-record-empty-list
                        loading="false"
                        [restrictedReason]="restrictedNhsReason"
                        [secondaryEmptyMessage]="secondaryEmptyMessage"
                        [loadingMessage]="secondaryEmptyMessage" />
                </td>
            </tr>
        </ng-template>
    </grid>
</div>

<m-historical-dialog [(visible)]="showHistorical" [items]="historicalItems"></m-historical-dialog>

<formio-select-patient-dialog
    *ngIf="displaySelectPatientDialog"
    (onOk)="selectPatientForNewFormData($event)"
    (onCancel)="cancelPatientSelectionForNewFormData()">
</formio-select-patient-dialog>

<formio-filtered-form-select-dialog
    *ngIf="!!displayFormDialog && currentUserHasWritePermissions"
    [visible]="displayFormDialog && currentUserHasWritePermissions"
    [categories]="categoryName"
    (onCancel)="displayFormDialog = false">
</formio-filtered-form-select-dialog>